var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "w-full" },
    [
      _vm._l(_vm.softwareCart, function (product) {
        return _c("div", { key: product }, [
          _c(
            "div",
            { staticClass: "flex justify-between pb-1" },
            [
              _c("div", { staticClass: "leading-0" }, [
                _c("div", { staticClass: "font-semibold" }, [
                  _vm._v(_vm._s(product.name)),
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    _vm._s(
                      _vm.renewalsPersistedVariables.jsonContent.text.startingAt
                    ) +
                      " " +
                      _vm._s(_vm.productPrices[product.name].unitPrice) +
                      _vm._s(
                        _vm.paymentType !== "upfront"
                          ? `/${
                              _vm.renewalsPersistedVariables.jsonContent.text[
                                _vm.paymentType
                              ]
                            }`
                          : ""
                      )
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("QuantityToggle", {
                attrs: {
                  default: product.adjusted_quantity,
                  renewalFlow: true,
                  max: product.quantity,
                  min: 0,
                  maxedOut: false,
                  productKeyOverride: product.product_code,
                },
                on: { input: (event) => _vm.setKey(product, event) },
              }),
            ],
            1
          ),
        ])
      }),
      _vm._v(" "),
      _vm.showDownsizeDropdown
        ? _c("Dropdown", {
            staticClass: "pt-1",
            attrs: { step: _vm.generateFirstStep(), required: "true" },
            model: {
              value: _vm.firstDropdownAnswer,
              callback: function ($$v) {
                _vm.firstDropdownAnswer = $$v
              },
              expression: "firstDropdownAnswer",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showDownsizeDropdown && _vm.firstDropdownAnswer?.valid
        ? _c("Dropdown", {
            staticClass: "pt-2",
            attrs: { step: _vm.generateSecondStep(), required: "true" },
            model: {
              value: _vm.secondDropdownAnswer,
              callback: function ($$v) {
                _vm.secondDropdownAnswer = $$v
              },
              expression: "secondDropdownAnswer",
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }